/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { shape, bool, number, string, func } from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import classNames from 'clsx';

import { createUrl } from 'utils/urlHelper';

import { getShortlist as getShortlistAction } from 'actions/shortlist';

import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';
import Spinner from 'components/Spinner/Spinner';
import Counter from 'components/Counter/Counter';

import styles from './likes-button.scss';

/**
 * This is the LikesButton component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class LikesButton extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    white: bool,
    shortlist: shape({
      loading: bool,
      likelist_id: string,
      likes: shape({
        talent_count: number,
      }),
    }).isRequired,
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    getShortlist: func.isRequired,
  };

  componentDidMount() {
    const {
      auth: { token },
      shortlist: {
        likes: { talent_count },
        likelist_id,
      },
      getShortlist,
    } = this.props;

    if (talent_count <= 0 && likelist_id) {
      getShortlist(token, likelist_id);
    }
  }

  componentDidUpdate(prevProps) {
    const { shortlist: prevShortlist } = prevProps;
    const {
      auth: { token },
      shortlist,
      getShortlist,
    } = this.props;

    if (
      prevShortlist.likelist_id !== shortlist.likelist_id &&
      !shortlist.loading &&
      shortlist.likelist_id
    ) {
      getShortlist(token, shortlist.likelist_id);
    }
  }

  /**
   * Render LikesButton.
   *
   * @return {Object}
   */
  render() {
    const {
      white,
      shortlist: {
        loading,
        likelist_id,
        likes: { talent_count },
      },
    } = this.props;

    return (
      <NavLink to={createUrl('likes', likelist_id)} className={styles.wrapper}>
        {loading && (
          <span className={styles.inner}>
            <Spinner small />
          </span>
        )}

        {!loading && (
          <span className={styles.inner}>
            <BlackTieIcon
              icon="heart"
              weight="btr"
              className={classNames(styles.icon, {
                [styles.white]: white,
              })}
            />

            {talent_count > 0 && <Counter dark count={talent_count} />}
          </span>
        )}
      </NavLink>
    );
  }
}

export default connect(({ auth, shortlist }) => ({ auth, shortlist }), {
  getShortlist: getShortlistAction,
})(LikesButton);
